import { Component,  Input, Output, EventEmitter } from '@angular/core';
import { ToggleTabComponent } from '../buttons/toggle-tab.component';
import { GreyWrapperComponent } from './grey-wrapper.component';
@Component({
    selector: 'toggle-wrapper',
    template: `
<div class="toggle-wrapper">
  <grey-wrapper>
    <ng-content></ng-content>
  </grey-wrapper>
  <div class="toggles">
    <toggle-tab [hideToggle]="readOnly" [text]="toggleText" [toggled]="toggled" (toggle)="onToggle.emit()"></toggle-tab>
  </div>
</div>

`,
    styles: [`
  .toggles { display: flex; flex-direction: row-reverse; }
`],
    standalone: true,
    imports: [ToggleTabComponent, GreyWrapperComponent],
})
export class ToggleWrapperComponent {

  @Input() readOnly
  @Input() toggleText
  @Input() toggled = false
  @Output() onToggle: EventEmitter<boolean> = new EventEmitter()

}




